import React from 'react';
import { CalendarEvent } from '../../types/ics';
import { Calendar, Clock, MapPin } from 'lucide-react';

interface EventCardProps {
  event: CalendarEvent;
}

const formatDate = (date: Date): string => {
  return date.toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const EventCard: React.FC<EventCardProps> = ({ event }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-4 hover:shadow-lg transition-shadow">
      <h3 className="text-xl font-semibold text-gray-800 mb-2">{event.summary}</h3>
      
      <div className="space-y-2">
        <div className="flex items-center text-gray-600">
          <Calendar className="w-5 h-5 mr-2" />
          <span>{formatDate(event.startDate)}</span>
        </div>
        
        <div className="flex items-center text-gray-600">
          <Clock className="w-5 h-5 mr-2" />
          <span>{formatDate(event.endDate)}</span>
        </div>
        
        {event.location && (
          <div className="flex items-center text-gray-600">
            <MapPin className="w-5 h-5 mr-2" />
            <span>{event.location}</span>
          </div>
        )}
      </div>
      
      {event.description && (
        <p className="mt-4 text-gray-600 text-sm">{event.description}</p>
      )}
    </div>
  );
};